import React, { FC, useMemo } from "react";
import { ErrorFallback } from "@/components";
import NotificationsDropdown from "@/features/notifications/components/bell/Notifications.fetcher";

interface NotificationRenderProps {
  profile: any;
  currentUser: any;
}

const NotificationRender: FC<NotificationRenderProps> = ({
  profile,
  currentUser,
}): JSX.Element => {
  return useMemo(() => {
    try {
      return (
        <>{profile && <NotificationsDropdown currentUser={currentUser} />}</>
      );
    } catch {
      return <ErrorFallback />;
    }
  }, [currentUser]);
};

export default NotificationRender;
